import e, { forwardRef as x } from "react";
import { Progress as r } from "@ark-ui/react";
import { cx as T, css as b } from "@huspy/styled-system/css";
import { splitCssProps as d, Flex as k } from "@huspy/styled-system/jsx";
import { progress as o } from "@huspy/styled-system/recipes";
const f = x((n, m) => {
  const [i, p] = o.splitVariantProps(n), [g, u] = d(p), {
    children: t,
    className: E,
    type: s = "linear",
    rangeColor: l,
    trackColor: c,
    showValueText: N,
    ...P
  } = u, a = o(i);
  return /* @__PURE__ */ e.createElement(
    r.Root,
    {
      ref: m,
      className: T(a.root, b(g), E),
      ...P
    },
    s === "linear" && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(k, { justifyContent: "space-between", width: "100%", alignItems: "end" }, t && /* @__PURE__ */ e.createElement(r.Label, { className: a.label }, t), N && /* @__PURE__ */ e.createElement(r.ValueText, { className: a.valueText })), /* @__PURE__ */ e.createElement(r.Track, { className: a.track, style: { background: c } }, /* @__PURE__ */ e.createElement(
      r.Range,
      {
        className: a.range,
        style: { background: l }
      }
    ))),
    s === "circular" && /* @__PURE__ */ e.createElement(e.Fragment, null, t && /* @__PURE__ */ e.createElement(r.Label, { className: a.label }, t), /* @__PURE__ */ e.createElement(r.Circle, { className: a.circle }, /* @__PURE__ */ e.createElement(
      r.CircleTrack,
      {
        className: a.circleTrack,
        style: { background: c }
      }
    ), /* @__PURE__ */ e.createElement(
      r.CircleRange,
      {
        className: a.circleRange,
        style: { background: l }
      }
    ), /* @__PURE__ */ e.createElement(r.ValueText, { className: a.valueText })), /* @__PURE__ */ e.createElement(r.ValueText, { className: a.valueText }))
  );
});
f.displayName = "Progress";
export {
  f as Progress
};
